import {
  ADMIN_ROUTE_PREFIX,
  isNavPathActive,
  isTopicActive,
  NavTopic,
  PRIMARY_NAV_TOPICS,
  SECONDARY_NAV_TOPICS,
} from '../constants/appNavigation';
import { resolvePageInfo } from './routePageMeta';

export interface BreadcrumbSegment {
  label: string;
  path?: string;
}

const NAV_TOPICS: NavTopic[] = [...PRIMARY_NAV_TOPICS, ...SECONDARY_NAV_TOPICS];

function findActiveChild(pathname: string, search: string): { topic: NavTopic; childLabel: string; childPath: string } | null {
  for (const topic of NAV_TOPICS) {
    if (!topic.children?.length) {
      continue;
    }

    const activeChild = topic.children.find((child) => isNavPathActive(pathname, search, child.path));
    if (activeChild) {
      return { topic, childLabel: activeChild.label, childPath: activeChild.path };
    }
  }

  return null;
}

function findActiveTopic(pathname: string, search: string): NavTopic | null {
  return NAV_TOPICS.find((topic) => isTopicActive(pathname, search, topic)) ?? null;
}

export function resolveRouteBreadcrumbs(pathname: string, search: string): BreadcrumbSegment[] {
  const path = pathname || '/';

  if (path.startsWith(ADMIN_ROUTE_PREFIX)) {
    if (path === '/admin/login') {
      return [{ label: 'Sign in' }];
    }
    if (path.startsWith('/admin/msme/')) {
      return [
        { label: 'Admin', path: '/admin/dashboard' },
        { label: 'MSME record' },
      ];
    }
    return [
      { label: 'Admin', path: '/admin/dashboard' },
      { label: resolvePageInfo(path).title },
    ];
  }

  const activeChild = findActiveChild(path, search);
  if (activeChild) {
    const segments: BreadcrumbSegment[] = [];
    if (path !== '/dashboard') {
      segments.push({ label: 'Home', path: '/dashboard' });
    }
    if (activeChild.topic.path !== '/dashboard') {
      segments.push({ label: activeChild.topic.label, path: activeChild.topic.path });
    }
    segments.push({ label: activeChild.childLabel, path: activeChild.childPath });
    return segments;
  }

  const activeTopic = findActiveTopic(path, search);
  if (activeTopic) {
    if (path === '/dashboard') {
      return [{ label: activeTopic.label }];
    }
    return [
      { label: 'Home', path: '/dashboard' },
      { label: activeTopic.label, path: activeTopic.path },
    ];
  }

  const pageTitle = resolvePageInfo(path).title;
  if (path === '/dashboard') {
    return [{ label: pageTitle }];
  }

  return [
    { label: 'Home', path: '/dashboard' },
    { label: pageTitle },
  ];
}
